import React from 'react';

const PerformanceTab = ({ selected, performance, isButtonSelected }) => {
  if (!performance) {
    return null;
  }

  return (
    <div className={`tabbed-content-container${selected ? ' selected' : ''}`} meta-tab="5">
      <h2>{performance.title}</h2>
      {Object.keys(performance).length > 0 &&
        Object.entries(performance.data).map(([key, performanceGroup]) => {
          if (!performanceGroup?.[0]) {
            return null;
          }

          if (!isButtonSelected(performanceGroup[0].frequency, performanceGroup[0].metric)) {
            return null;
          }

          return (
            <React.Fragment key={key}>
              {performanceGroup.map((perf, index) => (
                <div className="performance" data-frequency={key} key={index}>
                  <img src={`${import.meta.env.VITE_IMAGES_BASE}${perf.image}`} alt={perf.alt} />
                  <p dangerouslySetInnerHTML={{ __html: perf.caption }} />
                </div>
              ))}
            </React.Fragment>
          );
        })}
    </div>
  );
};

export default PerformanceTab;
